
import { ParteProps } from "./ParteInterface";

// Definición de defaults

export const defaultPromocion: PromocionProps = {
    idPromocion:             0,
    idTipoPromocion:         0,
    tipoPromocion:           '',
    folioBuzonElectronico:   '',
    escritoBuzonElectronico: '',
    acuseBuzonElectronico:   '',
    digitalizacion:          '',
    idEstatus:               0,
    estatus:                 '',
    actores:                 [],
    demandados:              [],
    partes:                  [],
    anexosBuzonElectronico:  [],
}

// Creación de interfaces

export interface PromocionProps {
    idPromocion:             number;
    idTipoPromocion:         number;
    tipoPromocion:           string;
    folioBuzonElectronico:   string;
    escritoBuzonElectronico: string;
    acuseBuzonElectronico:   string;
    digitalizacion:          string;
    idEstatus:               number;
    estatus:                 string;
    partes:                  ParteProps[];
    actores:                 string[];
    demandados:              string[];
    anexosBuzonElectronico:  AnexoBuzonElectronicoProps[];
    fecha?:                  Date;
}

export interface AnexoBuzonElectronicoProps {
    archivo:        string;          
    descripcion:    string;                  
    url:            string;   
}

